var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSoundMp3 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2440 4844 c-17 -15 -42 -48 -55 -75 l-25 -48 0 -1486 0 -1485 -45 34 c-107 82 -324 119 -561 97 -142 -14 -243 -40 -350 -90 -325 -153 -524 -458 -524 -803 0 -113 17 -187 69 -293 87 -176 264 -315 484 -379 246 -71 503 -50 737 60 301 142 463 391 515 792 13 94 15 301 15 1234 0 954 2 1119 14 1115 8 -3 62 -36 122 -72 344 -213 592 -460 680 -675 48 -118 67 -316 43 -459 -16 -99 -57 -214 -105 -292 -24 -39 -44 -78 -44 -86 0 -39 27 -100 61 -135 32 -33 41 -38 83 -38 65 0 111 26 187 107 119 126 230 324 299 532 61 182 75 265 74 431 -1 166 -25 277 -87 414 -79 170 -181 300 -436 559 -164 167 -249 238 -421 355 -168 113 -249 207 -410 472 -93 153 -108 172 -169 211 -58 38 -108 38 -151 3z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSoundMp3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sound-mp3.15c508fe.svg";
export { ForwardRef as ReactComponent };